//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "../../transitions/Expand.vue";
export default {
  name: "BlueFilterGroup",
  components: { TransitionExpand },
  props: ["group", "initiallyExpanded"],
  data() {
    return {
      active: this.initiallyExpanded,
    };
  },
  created() {
    const recurse = (filters) => {
      let hasSelections = false;
      filters.forEach((filter) => {
        if (filter.selected) {
          hasSelections = true;
        }
        else if (filter.filters && filter.filters.length) {
          if (recurse(filter.filters)) hasSelections = true;
        }
      });
      return hasSelections;
    };
    if (recurse(this.group.filters)) this.active = true;
  },
};
